var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_16294_62364)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9701 11.9993C22.4568 12.2327 21.9034 12.386 21.3301 12.4593C21.9168 12.106 22.3701 11.546 22.5834 10.8727C22.0301 11.206 21.4168 11.4393 20.7701 11.5727C20.2434 10.9993 19.5034 10.666 18.6634 10.666C17.0968 10.666 15.8168 11.946 15.8168 13.526C15.8168 13.7527 15.8434 13.9727 15.8901 14.1793C13.5168 14.0593 11.4034 12.9193 9.99677 11.1927C9.7501 11.6127 9.6101 12.106 9.6101 12.626C9.6101 13.6193 10.1101 14.4993 10.8834 14.9993C10.4101 14.9993 9.9701 14.866 9.58344 14.666C9.58344 14.666 9.58344 14.666 9.58344 14.686C9.58344 16.0727 10.5701 17.2327 11.8768 17.4927C11.6368 17.5593 11.3834 17.5927 11.1234 17.5927C10.9434 17.5927 10.7634 17.5727 10.5901 17.5393C10.9501 18.666 11.9968 19.506 13.2568 19.526C12.2834 20.2993 11.0501 20.7527 9.70344 20.7527C9.47677 20.7527 9.2501 20.7393 9.02344 20.7127C10.2901 21.526 11.7968 21.9993 13.4101 21.9993C18.6634 21.9993 21.5501 17.6393 21.5501 13.8593C21.5501 13.7327 21.5501 13.6127 21.5434 13.486C22.1034 13.086 22.5834 12.5793 22.9701 11.9993Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16294_62364",
    x1: 4.23938,
    y1: 5.15125,
    x2: 29.6369,
    y2: 24.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F9BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F9AE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dfe769f241aade66d09c8d02730eb0ef.svg";
export { ForwardRef as ReactComponent };